import { Badge } from "@/components/ui/badge";
import { getQuoteStatusLabel } from "@/lib/quote-status";

type QuoteStatus = "draft" | "confirmed" | "sent" | "accepted" | "rejected" | "shared";

interface StatusBadgeProps {
  status: string;
}

const statusConfig: Record<QuoteStatus, { label: string; variant: "default" | "secondary" | "destructive" | "outline" }> = {
  draft: { label: "Draft", variant: "secondary" },
  confirmed: { label: "Confirmed", variant: "default" },
  sent: { label: "Submitted", variant: "default" },
  accepted: { label: "Accepted", variant: "default" },
  rejected: { label: "Rejected", variant: "default" },
  shared: { label: "Shared With You", variant: "default" },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status as QuoteStatus] || { label: getQuoteStatusLabel(status), variant: "secondary" as const };
  
  return (
    <Badge 
      variant={config.variant}
      className={
        status === "accepted" 
          ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400" 
          : status === "rejected"
          ? "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400"
          : status === "sent"
          ? "bg-primary/10 text-primary dark:bg-primary/20 dark:text-primary"
          : status === "confirmed"
          ? "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400"
          : status === "shared"
          ? "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400"
          : ""
      }
      data-testid={`badge-status-${status}`}
    >
      {config.label}
    </Badge>
  );
}
